
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"36","height":"36","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22.491 18c0 6.214-5.034 11.249-11.245 11.249C5.034 29.249 0 24.213 0 17.999 0 11.788 5.035 6.752 11.246 6.752c6.21 0 11.245 5.036 11.245 11.249z","fill":"#E2574C"}}),_c('path',{attrs:{"d":"M24.751 6.751c-2.522 0-4.844.84-6.72 2.243l.009.001c.37.357.776.608 1.09 1.018l-2.34.037c-.366.37-.7.773-1.015 1.192H19.9c.313.376.604.704.867 1.12h-5.742c-.21.362-.405.735-.574 1.121h6.97c.182.386.345.678.483 1.086H14.04c-.125.388-.232.785-.313 1.19h8.509c.083.39.147.75.191 1.116h-8.869c-.037.37-.056.746-.056 1.125h8.99c0 .398-.029.767-.07 1.125h-8.864c.038.381.095.756.17 1.125h8.494c-.087.364-.189.731-.316 1.111h-7.892c.12.385.264.758.423 1.123h6.986c-.194.41-.413.737-.655 1.12h-5.76c.227.394.477.77.75 1.13l4.144.061c-.354.424-.807.68-1.22 1.051.023.018-.66-.002-2.004-.023a11.208 11.208 0 008.074 3.426C30.964 29.249 36 24.213 36 18c0-6.213-5.035-11.249-11.249-11.249z","fill":"#F4B459"}})])
          )
        }
      }
    